module.exports = __webpack_public_path__ + "img/crh.f57618f1.svg";